import { ContractForm } from '@crm/components/InfoTabs/Tabs/ContractsCol/ContractForm'
import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

const formName = 'add-contract-status-form'

type Props = {
  open: boolean
  opportunityId?: number
  onSuccess: () => void
  onCancel: () => void
}

export const AddContractModal = ({
  open,
  opportunityId,
  onSuccess,
  onCancel
}: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={t('lead.contracts')}
      width={800}
      destroyOnHidden
      maskClosable={false}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      okButtonProps={{ htmlType: 'submit', form: formName }}
    >
      <ContractForm
        formName={formName}
        opportunityIdProp={opportunityId}
        onSuccess={onSuccess}
      />
    </Modal>
  )
}
